import React from "react";

export default function CopaAfroVeg() {
  const jogos = [
    {
      grupo: "Grupo A",
      pais: "África do Sul",
      bandeira: "https://flagcdn.com/w80/za.png",
      prato: "Chakalaka vegano com arroz aromático",
      partidas: [
        {
          data: "11 de junho (Qui)",
          hora: "16h",
          jogo: "África do Sul x México",
        },
        {
          data: "18 de junho (Qui)",
          hora: "13h",
          jogo: "África do Sul x República Tcheca",
        },
        {
          data: "24 de junho (Qua)",
          hora: "A definir",
          jogo: "África do Sul x Coreia do Sul",
        },
      ],
    },

    {
      grupo: "Grupo C",
      pais: "Marrocos",
      bandeira: "https://flagcdn.com/w80/ma.png",
      prato: "Tagine vegano de legumes com grão-de-bico",
      partidas: [
        {
          data: "13 de junho (Sáb)",
          hora: "19h",
          jogo: "Marrocos x Brasil",
        },
        {
          data: "19 de junho (Sex)",
          hora: "19h",
          jogo: "Marrocos x Escócia",
        },
        {
          data: "24 de junho (Qua)",
          hora: "19h",
          jogo: "Marrocos x Haiti",
        },
      ],
    },

    {
      grupo: "Grupo F",
      pais: "Tunísia",
      bandeira: "https://flagcdn.com/w80/tn.png",
      prato: "Cuscuz tunisiano vegano com legumes",
      partidas: [
        {
          data: "14 de junho (Sáb)",
          hora: "23h",
          jogo: "Tunísia x Suécia",
        },
        {
          data: "21 de junho (Dom)",
          hora: "01h",
          jogo: "Tunísia x Japão",
        },
        {
          data: "25 de junho (Qui)",
          hora: "20h",
          jogo: "Tunísia x Holanda",
        },
      ],
    },

    {
      grupo: "Grupo G",
      pais: "Egito",
      bandeira: "https://flagcdn.com/w80/eg.png",
      prato: "Koshari vegano egípcio",
      partidas: [
        {
          data: "15 de junho (Seg)",
          hora: "22h",
          jogo: "Egito x Bélgica",
        },
        {
          data: "21 de junho (Sáb)",
          hora: "22h",
          jogo: "Egito x Nova Zelândia",
        },
        {
          data: "27 de junho (Sex)",
          hora: "00h",
          jogo: "Egito x Irã",
        },
      ],
    },

    {
      grupo: "Grupo H",
      pais: "Cabo Verde",
      bandeira: "https://flagcdn.com/w80/cv.png",
      prato: "Cachupa vegana crioula",
      partidas: [
        {
          data: "15 de junho (Seg)",
          hora: "13h",
          jogo: "Cabo Verde x Espanha",
        },
        {
          data: "Data a definir",
          hora: "-",
          jogo: "Cabo Verde x Uruguai",
        },
        {
          data: "Data a definir",
          hora: "-",
          jogo: "Cabo Verde x Arábia Saudita",
        },
      ],
    },

    {
      grupo: "Grupo I",
      pais: "Senegal",
      bandeira: "https://flagcdn.com/w80/sn.png",
      prato: "Mafé senegalês vegano com arroz",
      partidas: [
        {
          data: "16 de junho (Ter)",
          hora: "16h",
          jogo: "Senegal x França",
        },
        {
          data: "22 de junho (Seg)",
          hora: "21h",
          jogo: "Senegal x Noruega",
        },
        {
          data: "26 de junho (Sex)",
          hora: "16h",
          jogo: "Senegal x Iraque",
        },
      ],
    },

    {
      grupo: "Grupo J",
      pais: "Argélia",
      bandeira: "https://flagcdn.com/w80/dz.png",
      prato: "Chorba argelina vegana",
      partidas: [
        {
          data: "16 de junho (Ter)",
          hora: "22h",
          jogo: "Argélia x Argentina",
        },
        {
          data: "Data a definir",
          hora: "-",
          jogo: "Argélia x Jordânia",
        },
        {
          data: "Data a definir",
          hora: "-",
          jogo: "Argélia x Áustria",
        },
      ],
    },

    {
      grupo: "Grupo K",
      pais: "RD Congo",
      bandeira: "https://flagcdn.com/w80/cd.png",
      prato: "Fufu com mwamba e legumes congoleses",
      partidas: [
        {
          data: "17 de junho (Qua)",
          hora: "14h",
          jogo: "RD Congo x Portugal",
        },
        {
          data: "23 de junho (Ter)",
          hora: "23h",
          jogo: "RD Congo x Colômbia",
        },
        {
          data: "27 de junho (Sáb)",
          hora: "20h30",
          jogo: "RD Congo x Uzbequistão",
        },
      ],
    },

    {
      grupo: "Grupo L",
      pais: "Gana",
      bandeira: "https://flagcdn.com/w80/gh.png",
      prato: "Jollof rice vegano",
      partidas: [
        {
          data: "17 de junho (Qua)",
          hora: "20h",
          jogo: "Gana x Panamá",
        },
        {
          data: "23 de junho (Ter)",
          hora: "17h",
          jogo: "Gana x Inglaterra",
        },
        {
          data: "27 de junho (Sáb)",
          hora: "18h",
          jogo: "Gana x Croácia",
        },
      ],
    },
  ];

  return (
    <section className="bg-neutral-950 text-white px-4 py-14">
      <div className="max-w-7xl mx-auto">

        <div className="text-center mb-12">
          <span className="text-yellow-400 font-bold text-lg">
            🌍 Copa AfroVeg 2026
          </span>

          <h2 className="text-4xl font-bold mt-4 mb-4">
            Jogos das Seleções Africanas no Congolinaria
          </h2>

          <p className="text-neutral-300 max-w-3xl mx-auto text-lg">
            Durante a Copa do Mundo, cada jogo das seleções africanas será
            celebrado com pratos especiais inspirados em cada país,
            em versão 100% plant-based.
          </p>
        </div>

        <div className="grid gap-6 lg:grid-cols-2">
          {jogos.map((time, index) => (
            <div
              key={index}
              className="bg-neutral-900 border border-yellow-500 rounded-3xl p-6"
            >
              <div className="flex items-center gap-4 mb-5">

                <img
                  src={time.bandeira}
                  alt={time.pais}
                  className="w-14 h-10 object-cover rounded shadow-md"
                />

                <div>
                  <p className="text-yellow-400 font-semibold">
                    {time.grupo}
                  </p>

                  <h3 className="text-3xl font-bold">
                    {time.pais}
                  </h3>
                </div>
              </div>

              <div className="bg-neutral-800 rounded-2xl p-4 mb-5">
                <small className="text-neutral-400 block mb-1">
                  Prato especial do rodízio
                </small>

                <strong className="text-yellow-400 text-lg">
                  {time.prato}
                </strong>
              </div>

              <div className="space-y-3">
                {time.partidas.map((partida, idx) => (
                  <div
                    key={idx}
                    className="bg-neutral-800 rounded-xl p-4"
                  >
                    <p className="text-yellow-400 font-bold">
                      {partida.data} • {partida.hora}
                    </p>

                    <p className="text-white mt-1 text-lg">
                      {partida.jogo}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}